/**
 * Origin parsing for the intake form's message checks.
 * @module features/player-intake/utils/originOf
 */

/**
 * The origin of a URL, or null when it will not parse.
 * @param value - An absolute URL.
 * @returns The origin, or null.
 */
export const originOf = (value: string): string | null => {
  try {
    const { origin } = new URL(value);
    /*
     * An opaque URL — `data:`, a sandboxed frame — parses to the literal
     * string "null", and EVERY opaque-origin sender posts that same value. So
     * accepting it would make an origin comparison match any sandboxed frame
     * on the page rather than this form, which is no check at all (SE-8285).
     */
    return origin === "null" ? null : origin;
  } catch {
    return null;
  }
};
